import { Textarea } from '@chakra-ui/react';
import React, { ForwardedRef } from 'react';
import ResizeTextarea from 'react-textarea-autosize';

export const AutoResizeTextarea = React.forwardRef(
  (props, ref: ForwardedRef<HTMLTextAreaElement>) => {
    return (
      <Textarea
        minH="unset"
        overflow="hidden"
        w="100%"
        resize="none"
        ref={ref}
        minRows={1}
        as={ResizeTextarea}
        readOnly
        {...props}
      />
    );
  }
);
